import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import { Check, X, Copy } from "lucide-react";
import { toast, Toaster } from "sonner";

export default function Submitted() {
  const loc = useLocation();
  const p = new URLSearchParams(loc.search);
  const ref = p.get("ref");
  const status = p.get("status") || "submitted";
  const estimate = p.get("estimate");
  const reason = p.get("reason");
  const rejected = status === "rejected" || status === "duplicate";

  return (
    <SiteLayout>
      <Toaster richColors position="top-center" />
      <section className="section-py container-x max-w-2xl text-center">
        <div className={`w-20 h-20 rounded-full mx-auto flex items-center justify-center ${rejected ? "bg-destructive/10 text-destructive" : "bg-primary/10 text-primary"}`}>
          {rejected ? <X size={40} /> : <Check size={40} />}
        </div>
        <h1 className="mt-6 text-4xl md:text-5xl font-extrabold tracking-tight" data-testid="submitted-title">
          {rejected ? "Submission not accepted" : "Submission received!"}
        </h1>
        {!rejected ? (
          <>
            <p className="mt-4 text-muted-foreground text-lg">We'll email you at each status update. Payout drops once verification wraps up.</p>
            {estimate && <div className="mt-6 text-3xl font-extrabold text-primary">Estimated payout: ${Number(estimate).toFixed(2)}</div>}
          </>
        ) : (
          <p className="mt-4 text-destructive font-bold" data-testid="submitted-reason">{reason}</p>
        )}
        <div className="mt-10 card-soft flex items-center justify-between gap-4">
          <div className="text-left">
            <div className="text-xs uppercase font-bold text-muted-foreground">Your reference</div>
            <div className="font-mono font-extrabold text-lg" data-testid="submitted-reference">{ref}</div>
          </div>
          <button
            onClick={() => { navigator.clipboard.writeText(ref); toast.success("Copied"); }}
            className="btn-pill-outline text-xs px-5 py-2"
            data-testid="submitted-copy"
          ><Copy size={14} className="mr-1" /> Copy</button>
        </div>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to={`/track`} className="btn-pill text-sm" data-testid="submitted-track">Track this submission</Link>
          <Link to="/submit" className="btn-pill-outline text-sm">Submit another card</Link>
        </div>
      </section>
    </SiteLayout>
  );
}
